import { Image } from '@app/components'
import React, { CSSProperties } from 'react'

export const WaitV2Icon = ({ style }: { style?: CSSProperties }) => {
  return <Image preview={false} src="../images/wait-v2-icon.png" style={style} />
}
